import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { memo } from 'react';

import { REACTION_TYPE_COLORS, Reaction } from '../../model/reactions';

type Props = {
  reactions: Reaction[];
};

export const ReactionsTable = memo(({ reactions }: Props) => {
  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 'calc(100vh - 250px)' }}>
        <Table stickyHeader aria-label="reactions table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', width: '25%' }}>Code</TableCell>
              <TableCell sx={{ fontWeight: 'bold', width: '37.5%' }}>Поствакцинальные реакции</TableCell>
              <TableCell sx={{ fontWeight: 'bold', width: '37.5%' }}>Post-vaccination reactions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reactions.map((reaction, index) => {
              const backgroundColor = reaction.type ? REACTION_TYPE_COLORS[reaction.type] : 'transparent';

              return (
                <TableRow
                  key={`${reaction.code}-${index}`}
                  sx={{
                    backgroundColor: reaction.isCategory ? backgroundColor : `${backgroundColor}40`, // 40 - это прозрачность для обычных строк
                    '&:last-child td, &:last-child th': { border: 0 },
                  }}
                >
                  <TableCell
                    sx={{
                      fontWeight: reaction.isCategory ? 'bold' : 'normal',
                      fontFamily: reaction.isCategory ? 'inherit' : 'monospace',
                    }}
                  >
                    {reaction.code}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: reaction.isCategory ? 'bold' : 'normal',
                      fontSize: reaction.isCategory ? '1.05rem' : 'inherit',
                    }}
                  >
                    {reaction.ru}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: reaction.isCategory ? 'bold' : 'normal',
                      fontSize: reaction.isCategory ? '1.05rem' : 'inherit',
                    }}
                  >
                    {reaction.en}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
});

ReactionsTable.displayName = 'ReactionsTable';
